import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';
import { getEntity } from 'modules/entity/selectors';

const getState = (state: RootState) => state.websockets;

export const getWebsocketUrl = createSelector(
  getEntity,
  (entity) => entity.websocketUrl
);

export const getTimeoutAt = createSelector(getState, (state) => state.timeoutAt);
